module.exports = React.addons.CSSTransitionGroup;


//////////////////
// WEBPACK FOOTER
// external "React.addons.CSSTransitionGroup"
// module id = 445
// module chunks = 0